export const INNER_PADDING = 8;
export const PLAIN_INNER_PADDING = 6;
export const MOBILE_HEAD_FEATURES_MARGIN = 4;
